import React from "react";

const CameraLiveStream = () => {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src="/camera.html" 
        title="Camera Stream"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default CameraLiveStream;
